import {gql} from "@apollo/client";

export const HOME_CONTENT_PACKAGE_GET_CALCULATION_DATA = gql`
	query CalculationData(
		$comparisonId: UUID!
	) {
		calculationData(comparisonId: $comparisonId) {
			comparisonId
			calculationDate
			calculationInput {
				masterAgreementPackages {
					coverageRef
					coverageBuildings {
						clauseRef
						clauses {
							clauseExplanation
							clauseName
							clauseNumber
						}
						documentRef
						documents {
							attachmentDescription
							attachmentType
							urlAttachment
						}
						conditionRef
						conditionConditionDetails {
							documentRef
							documents {
								attachmentDescription
								attachmentType
								urlAttachment
							}
							conditionNumber
							conditionText
						}
						refKey
						sumInsured
						coverageCode
						totalInstallmentAmount
						deductibleAmount
						costsInstallmentAmount
						discountsInstallmentAmount
						grossPremiumInstallment
						insuranceTaxInstallmentAmount
						surchargesInstallmentAmount
						deductibleDescription
						netPremiumInstallment
						effectiveDate
						productDescription
						insuredFamilyComposition
					}
					coverageHomes {
						clauseRef
						clauses {
							clauseExplanation
							clauseName
							clauseNumber
						}
						documentRef
						documents {
							attachmentDescription
							attachmentType
							urlAttachment
						}
						conditionRef
						conditionConditionDetails {
							documentRef
							documents {
								attachmentDescription
								attachmentType
								urlAttachment
							}
							conditionNumber
							conditionText
						}
						refKey
						sumInsured
						coverageCode
						totalInstallmentAmount
						deductibleAmount
						costsInstallmentAmount
						discountsInstallmentAmount
						grossPremiumInstallment
						insuranceTaxInstallmentAmount
						surchargesInstallmentAmount
						deductibleDescription
						netPremiumInstallment
						effectiveDate
						productDescription
						insuredFamilyComposition
						insuredAmountTenantInterest
						insuredAmountMusicalInstruments
						insuredAmountCollections
						insuredAmountComputerEquipment
						insuredAmountValuablesOutdoors
						insuredAmountJewelry
						insuredAmountOther
						customProperties {
							insuredAmountAudioVideo
							insuredAmountAntiques
							insuredAmountArt
							infofolioSumInsured
						}
					}
					coverageLiabilities {
						clauseRef
						clauses {
							clauseExplanation
							clauseName
							clauseNumber
						}
						documentRef
						documents {
							attachmentDescription
							attachmentType
							urlAttachment
						}
						conditionRef
						conditionConditionDetails {
							documentRef
							documents {
								attachmentDescription
								attachmentType
								urlAttachment
							}
							conditionNumber
							conditionText
						}
						refKey
						sumInsured
						totalInstallmentAmount
						deductibleAmount
						costsInstallmentAmount
						discountsInstallmentAmount
						grossPremiumInstallment
						insuranceTaxInstallmentAmount
						surchargesInstallmentAmount
						netPremiumInstallment
						effectiveDate
						productDescription
						insuredFamilyComposition
						deductibleAmountDamageByChildren
					}
					objectRef
					objectBuildings {
						addressRef
						addresses {
							houseNumber
							houseNumberAddition
							postalCode
							houseLetter
						}
						constructionYear
						constructionOfRoof
						constructionOfWalls
						constructionOfFloors
						homeType
						propertyUseType
						rebuildCost
						solarPanels
						borgAlarmClassification
						areaOutbuildingsSquareMeters
						burglaryPreventionMeasuresPresent
						consideredMonumentByOwner
						constructionGroundFloor
						houseSurfaceAreaSquareMeters
						numberRooms
						propertyOfInsured
						recentBathroomKitchenLivingRoom
						roofConstructionMaterialType
						volumeInCubicMeters
						wozAppraisalValue
						objectRentedOut
						businessUse
						customProperties {
							foundationType
							infofolioRebuildCost
						}
					}
					objectGlasses {
						translucentMaterialType
					}
					partyRef
					partyPolicyHolders {
						addresses {
							houseNumber
							houseNumberAddition
							postalCode
							houseLetter
						}
						surname
						initials
						prefixes
						telephoneNumber
						email
						genderOrLegalPersonType
						birthDate
						mobile
						collectionAccountIban
						callName
						customProperties {
							consumentenbondMember
							consumentenbondMemberEmail
							consumentenbondMemberConditions
							consumentenbondMemberContribution
							consumentenbondNewsletter
							consumentenbondUserId
							consumentenbondUserIsMember
						}
					}
					policyRef
					policyPolicyDetails {
						coverageRef
						coverageBuildings {
							clauseRef
							clauses {
								clauseExplanation
								clauseName
								clauseNumber
							}
							documentRef
							documents {
								attachmentDescription
								attachmentType
								urlAttachment
							}
							conditionRef
							conditionConditionDetails {
								documentRef
								documents {
									attachmentDescription
									attachmentType
									urlAttachment
								}
								conditionNumber
								conditionText
							}
							refKey
							sumInsured
							coverageCode
							totalInstallmentAmount
							deductibleAmount
							costsInstallmentAmount
							discountsInstallmentAmount
							grossPremiumInstallment
							insuranceTaxInstallmentAmount
							surchargesInstallmentAmount
							deductibleDescription
							netPremiumInstallment
							effectiveDate
							productDescription
							insuredFamilyComposition
						}
						coverageHomes {
							clauseRef
							clauses {
								clauseExplanation
								clauseName
								clauseNumber
							}
							documentRef
							documents {
								attachmentDescription
								attachmentType
								urlAttachment
							}
							conditionRef
							conditionConditionDetails {
								documentRef
								documents {
									attachmentDescription
									attachmentType
									urlAttachment
								}
								conditionNumber
								conditionText
							}
							refKey
							sumInsured
							coverageCode
							totalInstallmentAmount
							deductibleAmount
							costsInstallmentAmount
							discountsInstallmentAmount
							grossPremiumInstallment
							insuranceTaxInstallmentAmount
							surchargesInstallmentAmount
							deductibleDescription
							netPremiumInstallment
							effectiveDate
							productDescription
							insuredFamilyComposition
							insuredAmountTenantInterest
							insuredAmountMusicalInstruments
							insuredAmountCollections
							insuredAmountComputerEquipment
							insuredAmountValuablesOutdoors
							insuredAmountJewelry
							insuredAmountOther
							customProperties {
								insuredAmountAudioVideo
								insuredAmountAntiques
								insuredAmountArt
								infofolioSumInsured
							}
						}
						coverageLiabilities {
							clauseRef
							clauses {
								clauseExplanation
								clauseName
								clauseNumber
							}
							documentRef
							documents {
								attachmentDescription
								attachmentType
								urlAttachment
							}
							conditionRef
							conditionConditionDetails {
								documentRef
								documents {
									attachmentDescription
									attachmentType
									urlAttachment
								}
								conditionNumber
								conditionText
							}
							refKey
							sumInsured
							totalInstallmentAmount
							deductibleAmount
							costsInstallmentAmount
							discountsInstallmentAmount
							grossPremiumInstallment
							insuranceTaxInstallmentAmount
							surchargesInstallmentAmount
							netPremiumInstallment
							effectiveDate
							productDescription
							insuredFamilyComposition
							deductibleAmountDamageByChildren
						}
						contractDurationInMonths
						paymentTermInMonths
						contractNumber
						refKey
						productCode
						productDescription
						companyNameDescription
						marketingName
						offerNumber
						porCompany
						expectedAcquisitionCommissionPartnerAmount
					}
					underwritingRef
					underwritingCompanySpecifics {
						rejectionReason
						underwritingResult
					}
					underwritingUnderwritingQuestions {
						policyRefusedCancelledLimitedExplanation
						numberOfClaimsCurrentCarInsurance
						committedFraudPast8Years
						criminalRecordPastEightYears
						criminalRecordExplanation
						inAgreementWithClosingStatement
						financialProblems
						financialProblemsExplanation
						fraudulentActivitiesExplanation
						previousLossOrDamageDescription
						damageOrLossPastFiveYears
						numberOfClaims
						refusedPreviously
						seizureByBailiff
						seizureByBailiffExplanation
						abnAmroSpecialBuilding
						abnAmroPermanentlyInhabited
						abnAmroOrderDamageTooHigh
						abnAmroOrderMostRecentDamageYear
					}
					underwritingValuePreventionMeters {
						dateBirthMainBreadwinner
						monthlyNetIncomeMainBreadwinner
					}
					effectiveDate
					contractNumber
					porCompany
					productCode
					productDescription
					companyNameDescription
					costsInstallmentAmount
					grossPremiumInstallment
					insuranceTaxInstallmentAmount
					insuranceTaxPercentage
					netPremiumInstallment
					netPremiumInstallmentExcludingPackageDiscount
					numberOfSubPolicies
					offerNumber
					packageDiscountInstallmentAmount
					packageDiscountPercentage
					paymentTermInMonths
					returnCommissionPercentage
					surchargesInstallmentAmount
					totalInstallmentAmount
					installmentAmountRenewalCharges
					oneOffCostsAmount
					externalSourceName
					orderFormId
					expectedAcquisitionCommissionPartnerAmount
					customProperties {
						supplierKrn
						supplierExternalProductCategory
						buildingHomeCombinationTotalInstallmentAmount
					}
				}
				processRef
				processStatusNotifications {
					healthDeclarationExplanation
					messageCategoryDescription
					codedMessage
				}
				commonTechnical {
					accessCode
					senderId
					sessionId
					transactionReference
					googleAnalyticsId
					googleAnalyticsSessionId
				}
			}
			calculationOutput {
				masterAgreementPackages {
					coverageRef
					coverageBuildings {
						clauseRef
						clauses {
							clauseExplanation
							clauseName
							clauseNumber
						}
						documentRef
						documents {
							attachmentDescription
							attachmentType
							urlAttachment
						}
						conditionRef
						conditionConditionDetails {
							documentRef
							documents {
								attachmentDescription
								attachmentType
								urlAttachment
							}
							conditionNumber
							conditionText
						}
						refKey
						sumInsured
						coverageCode
						totalInstallmentAmount
						deductibleAmount
						costsInstallmentAmount
						discountsInstallmentAmount
						grossPremiumInstallment
						insuranceTaxInstallmentAmount
						surchargesInstallmentAmount
						deductibleDescription
						netPremiumInstallment
						effectiveDate
						productDescription
						insuredFamilyComposition
					}
					coverageHomes {
						clauseRef
						clauses {
							clauseExplanation
							clauseName
							clauseNumber
						}
						documentRef
						documents {
							attachmentDescription
							attachmentType
							urlAttachment
						}
						conditionRef
						conditionConditionDetails {
							documentRef
							documents {
								attachmentDescription
								attachmentType
								urlAttachment
							}
							conditionNumber
							conditionText
						}
						refKey
						sumInsured
						coverageCode
						totalInstallmentAmount
						deductibleAmount
						costsInstallmentAmount
						discountsInstallmentAmount
						grossPremiumInstallment
						insuranceTaxInstallmentAmount
						surchargesInstallmentAmount
						deductibleDescription
						netPremiumInstallment
						effectiveDate
						productDescription
						insuredFamilyComposition
						insuredAmountTenantInterest
						insuredAmountMusicalInstruments
						insuredAmountCollections
						insuredAmountComputerEquipment
						insuredAmountValuablesOutdoors
						insuredAmountJewelry
						insuredAmountOther
						customProperties {
							insuredAmountAudioVideo
							insuredAmountAntiques
							insuredAmountArt
							infofolioSumInsured
						}
					}
					coverageLiabilities {
						clauseRef
						clauses {
							clauseExplanation
							clauseName
							clauseNumber
						}
						documentRef
						documents {
							attachmentDescription
							attachmentType
							urlAttachment
						}
						conditionRef
						conditionConditionDetails {
							documentRef
							documents {
								attachmentDescription
								attachmentType
								urlAttachment
							}
							conditionNumber
							conditionText
						}
						refKey
						sumInsured
						totalInstallmentAmount
						deductibleAmount
						costsInstallmentAmount
						discountsInstallmentAmount
						grossPremiumInstallment
						insuranceTaxInstallmentAmount
						surchargesInstallmentAmount
						netPremiumInstallment
						effectiveDate
						productDescription
						insuredFamilyComposition
						deductibleAmountDamageByChildren
					}
					objectRef
					objectBuildings {
						addressRef
						addresses {
							houseNumber
							houseNumberAddition
							postalCode
							houseLetter
						}
						constructionYear
						constructionOfRoof
						constructionOfWalls
						constructionOfFloors
						homeType
						propertyUseType
						rebuildCost
						solarPanels
						borgAlarmClassification
						areaOutbuildingsSquareMeters
						burglaryPreventionMeasuresPresent
						consideredMonumentByOwner
						constructionGroundFloor
						houseSurfaceAreaSquareMeters
						numberRooms
						propertyOfInsured
						recentBathroomKitchenLivingRoom
						roofConstructionMaterialType
						volumeInCubicMeters
						wozAppraisalValue
						objectRentedOut
						businessUse
						customProperties {
							foundationType
							infofolioRebuildCost
						}
					}
					objectGlasses {
						translucentMaterialType
					}
					partyRef
					partyPolicyHolders {
						addresses {
							houseNumber
							houseNumberAddition
							postalCode
							houseLetter
						}
						surname
						initials
						prefixes
						telephoneNumber
						email
						genderOrLegalPersonType
						birthDate
						mobile
						collectionAccountIban
						callName
						customProperties {
							consumentenbondMember
							consumentenbondMemberEmail
							consumentenbondMemberConditions
							consumentenbondMemberContribution
							consumentenbondNewsletter
							consumentenbondUserId
							consumentenbondUserIsMember
						}
					}
					policyRef
					policyPolicyDetails {
						coverageRef
						coverageBuildings {
							clauseRef
							clauses {
								clauseExplanation
								clauseName
								clauseNumber
							}
							documentRef
							documents {
								attachmentDescription
								attachmentType
								urlAttachment
							}
							conditionRef
							conditionConditionDetails {
								documentRef
								documents {
									attachmentDescription
									attachmentType
									urlAttachment
								}
								conditionNumber
								conditionText
							}
							refKey
							sumInsured
							coverageCode
							totalInstallmentAmount
							deductibleAmount
							costsInstallmentAmount
							discountsInstallmentAmount
							grossPremiumInstallment
							insuranceTaxInstallmentAmount
							surchargesInstallmentAmount
							deductibleDescription
							netPremiumInstallment
							effectiveDate
							productDescription
							insuredFamilyComposition
						}
						coverageHomes {
							clauseRef
							clauses {
								clauseExplanation
								clauseName
								clauseNumber
							}
							documentRef
							documents {
								attachmentDescription
								attachmentType
								urlAttachment
							}
							conditionRef
							conditionConditionDetails {
								documentRef
								documents {
									attachmentDescription
									attachmentType
									urlAttachment
								}
								conditionNumber
								conditionText
							}
							refKey
							sumInsured
							coverageCode
							totalInstallmentAmount
							deductibleAmount
							costsInstallmentAmount
							discountsInstallmentAmount
							grossPremiumInstallment
							insuranceTaxInstallmentAmount
							surchargesInstallmentAmount
							deductibleDescription
							netPremiumInstallment
							effectiveDate
							productDescription
							insuredFamilyComposition
							insuredAmountTenantInterest
							insuredAmountMusicalInstruments
							insuredAmountCollections
							insuredAmountComputerEquipment
							insuredAmountValuablesOutdoors
							insuredAmountJewelry
							insuredAmountOther
							customProperties {
								insuredAmountAudioVideo
								insuredAmountAntiques
								insuredAmountArt
								infofolioSumInsured
							}
						}
						coverageLiabilities {
							clauseRef
							clauses {
								clauseExplanation
								clauseName
								clauseNumber
							}
							documentRef
							documents {
								attachmentDescription
								attachmentType
								urlAttachment
							}
							conditionRef
							conditionConditionDetails {
								documentRef
								documents {
									attachmentDescription
									attachmentType
									urlAttachment
								}
								conditionNumber
								conditionText
							}
							refKey
							sumInsured
							totalInstallmentAmount
							deductibleAmount
							costsInstallmentAmount
							discountsInstallmentAmount
							grossPremiumInstallment
							insuranceTaxInstallmentAmount
							surchargesInstallmentAmount
							netPremiumInstallment
							effectiveDate
							productDescription
							insuredFamilyComposition
							deductibleAmountDamageByChildren
						}
						contractDurationInMonths
						paymentTermInMonths
						contractNumber
						refKey
						productCode
						productDescription
						companyNameDescription
						marketingName
						offerNumber
						porCompany
						expectedAcquisitionCommissionPartnerAmount
					}
					underwritingRef
					underwritingCompanySpecifics {
						rejectionReason
						underwritingResult
					}
					underwritingUnderwritingQuestions {
						policyRefusedCancelledLimitedExplanation
						numberOfClaimsCurrentCarInsurance
						committedFraudPast8Years
						criminalRecordPastEightYears
						criminalRecordExplanation
						inAgreementWithClosingStatement
						financialProblems
						financialProblemsExplanation
						fraudulentActivitiesExplanation
						previousLossOrDamageDescription
						damageOrLossPastFiveYears
						numberOfClaims
						refusedPreviously
						seizureByBailiff
						seizureByBailiffExplanation
						abnAmroSpecialBuilding
						abnAmroPermanentlyInhabited
						abnAmroOrderDamageTooHigh
						abnAmroOrderMostRecentDamageYear
					}
					underwritingValuePreventionMeters {
						dateBirthMainBreadwinner
						monthlyNetIncomeMainBreadwinner
					}
					effectiveDate
					contractNumber
					porCompany
					productCode
					productDescription
					companyNameDescription
					costsInstallmentAmount
					grossPremiumInstallment
					insuranceTaxInstallmentAmount
					insuranceTaxPercentage
					netPremiumInstallment
					netPremiumInstallmentExcludingPackageDiscount
					numberOfSubPolicies
					offerNumber
					packageDiscountInstallmentAmount
					packageDiscountPercentage
					paymentTermInMonths
					returnCommissionPercentage
					surchargesInstallmentAmount
					totalInstallmentAmount
					installmentAmountRenewalCharges
					oneOffCostsAmount
					externalSourceName
					orderFormId
					expectedAcquisitionCommissionPartnerAmount
					customProperties {
						supplierKrn
						supplierExternalProductCategory
						buildingHomeCombinationTotalInstallmentAmount
					}
				}
				processRef
				processStatusNotifications {
					healthDeclarationExplanation
					messageCategoryDescription
					codedMessage
				}
				commonTechnical {
					accessCode
					senderId
					sessionId
					transactionReference
					googleAnalyticsId
					googleAnalyticsSessionId
				}
			}
			traces {
				providerTraces {
					krn
					message
					numberOfProducts
				}
				productTraces {
					krn
					supplierName
					totalInstallmentAmount
					underwritingResult
					productStatus
					filteredOut
				}
			}
		}
	}
`;
